(() => {
  const init = (root = document) => {
    root.querySelectorAll('[data-ng-card-slider]').forEach((slider) => {
      if (slider.dataset.ngSliderReady === 'true') return;
      slider.dataset.ngSliderReady = 'true';

      const slides = [...slider.querySelectorAll('[data-ng-card-slide]')];
      const shell = slider.closest('.ng-card__media-shell');
      const previous = shell && shell.querySelector('[data-ng-slider-prev]');
      const next = shell && shell.querySelector('[data-ng-slider-next]');
      const dots = shell ? [...shell.querySelectorAll('[data-ng-slider-dot]')] : [];
      if (slides.length < 2) return;

      let activeIndex = 0;
      let scrollTimer;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      const update = () => {
        const width = slider.clientWidth || 1;
        activeIndex = Math.max(0, Math.min(slides.length - 1, Math.round(slider.scrollLeft / width)));
        dots.forEach((dot, index) => {
          if (index === activeIndex) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        if (previous) previous.disabled = activeIndex === 0;
        if (next) next.disabled = activeIndex === slides.length - 1;
      };

      const goTo = (index) => {
        const target = Math.max(0, Math.min(slides.length - 1, index));
        slider.scrollTo({ left: target * slider.clientWidth, behavior: reducedMotion ? 'auto' : 'smooth' });
      };

      previous?.addEventListener('click', () => goTo(activeIndex - 1));
      next?.addEventListener('click', () => goTo(activeIndex + 1));
      dots.forEach((dot, index) => dot.addEventListener('click', () => goTo(index)));
      slider.addEventListener('scroll', () => {
        window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(update, 80);
      }, { passive: true });
      slider.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        goTo(activeIndex + (event.key === 'ArrowRight' ? 1 : -1));
      });
      window.addEventListener('resize', update, { passive: true });
      update();
    });
  };

  init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();